/* projects/speaker-platform/src/app/molecules/speaker-list-item/speaker-list-item.component.scss */
.speakerlistitem {
  padding: 16px;
  cursor: pointer;
}
.speakerlistitem__name {
  font-weight: 700;
}
.speakerlistitem--selected {
  background-color: #FAF8F4;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1607843137);
}
.speakerlistitem .legendStatus {
  margin-left: 4px;
  font-size: 12px;
  font-style: italic;
}
/*# sourceMappingURL=speaker-list-item.component-NESGKYET.css.map */
